import React from "react";
import Navbar from "../../../Navbar/Navbar";
import FormParadan from "./FormParadan";
import swal from "sweetalert";

class Paradan extends React.Component {
  constructor() {
    super();
    this.state = {
      savekrdn: false
    };
  }

  onSaveChange = (
    PD_nawebarez,
    PD_wasleShareka,
    PD_zhmaraybarez,
    PD_nawewargr,
    PD_brepara,
    PD_joredraw,
    PD_note
  ) => {
    if (
      PD_nawebarez.toString().length == 0 ||
      PD_wasleShareka == 0 ||
      PD_zhmaraybarez == 0 ||
      PD_nawewargr == null ||
      PD_brepara == 0 ||
      PD_joredraw == null ||
      PD_note.toString().length == 0
    ) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      this.setState({
        savekrdn: true
      });
      swal({
        title: "تەواو",
        text: "پسولە سورکەوتوو بوو!",
        icon: "success",
        timer: 2000
      });
    }
  };

  onNewPage = () => {
    this.setState({
      savekrdn: false
    });
  };
  render() {
    return (
      <>
        <Navbar />
        <div className="mt5"></div>
        <FormParadan
          onNewPage={this.onNewPage}
          onSaveChange={this.onSaveChange}
          savekrdn={this.state.savekrdn}
        />
      </>
    );
  }
}

export default Paradan;
